import { render } from "./KoTatouReportPanel.vue?vue&type=template&id=7c5b3bde"
import script from "./KoTatouReportPanel.vue?vue&type=script&lang=js"
export * from "./KoTatouReportPanel.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
